export default __webpack_public_path__ + "static/media/store.b8723aac.svg";